import { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import { checkSession } from "../globalStore/slices/user/userSlice";
import { init } from "../globalStore/slices/organization/organizationSlice";
import { initAssetHistory } from "../globalStore/slices/assetHistory/thunks/init";
import { initAssets } from "../globalStore/slices/assets/thunks/init";
import { initDevices } from "../globalStore/slices/devices/devicesSlice";
import { initInventoryHistory } from "../globalStore/slices/inventoryHistory/thunks/init";
import { initSettings } from "../globalStore/slices/settings/thunks/init";
import { LicenseInfo } from "@mui/x-license-pro";
import { Box, Grow } from "@mui/material";
import { theme } from "../styles/MuiTheme";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import AuthContainer from "./auth";
import lxlogobluegreen from "./../assets/lxlogobluegreen.png";
import NoAuthContainer from "./noAuth";

export default function App() {
  const classes = {
    container: {
      display: "flex",
      height: "100vh",
      alignItems: "center",
      justifyContent: "center",
    },
    icon: {
      maxWidth: "300px",
    },
  }
  const [auth, setAuth] = useState({
    isInitializing: true,
    isAuthed: false,
  });

  const dispatch = useDispatch();

  // Setting the licence key for MaterialUi
  //Expires Oct 28, 2024
  LicenseInfo.setLicenseKey(
    "4198f57f6bcb5f5c1ba3155050c9bbf7Tz04ODM0NixFPTE3NDQ1NjYxNzcwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y"
  );


  // first render, check session and update store with user data, then dispatch init thunk to organization slice and update store with organization data
  useEffect(() => {
    dispatch(checkSession(localStorage.getItem("token"))).then((res) => {
      if (res.payload?.success) {
        dispatch(init()).then((res) => {
          // dispatching other initializors for our store.
          dispatch(initDevices());
          dispatch(initAssets());
          dispatch(initAssetHistory());
          dispatch(initInventoryHistory());
          dispatch(initSettings());

          // after one second, ending intialization sequence and reporting whether the user's session is valid (isAuthed)
          setTimeout(() => {
            setAuth({
              isInitializing: false,
              isAuthed: res?.payload?.success || false,
            });
          }, 1000);
        });
      } else {
        setTimeout(() => {
          setAuth({ isInitializing: false, isAuthed: false });
        }, 1000);
      }
    });
  }, [dispatch]);

  const { isInitializing, isAuthed } = auth;

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        {isInitializing ? (
          <Box sx={classes.container}>
            <Grow
              in={isInitializing}
              style={{ transformOrigin: "0 0 0 0" }}
              timeout={1000}
            >
              <img src={lxlogobluegreen} style={classes.icon} alt="LocatorX launch logo" />
            </Grow>
          </Box>
        ) : (
          <Router>
            {isAuthed ? (
              <>
                <AuthContainer setAuth={setAuth} />
              </>
            ) : (
              <NoAuthContainer setAuth={setAuth} />
            )}
          </Router>
        )}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
